import {View, Text, Modal, TouchableOpacity} from 'react-native';
import React from 'react';
import Feather from 'react-native-vector-icons/Feather';
import {Colors} from '../../../../constants/Colors';

import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import {styles} from './styles';
import {useNavigation} from '@react-navigation/native';

interface IModalFilter {
  visible: boolean;
  date: string | null;
  onRequestClose: () => void;
  onPress: () => void;
}

type RootStackParamList = {
  Orders: undefined;
};

const OrderScheduledModal = ({
  visible,
  date,
  onRequestClose,
  onPress,
}: IModalFilter) => {
  const {navigate} = useNavigation();

  const handleOrdersPress = () => {
    navigate('Meus pedidos');
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <View style={styles.spaceHorizontal}>
            <TouchableOpacity onPress={onRequestClose}>
              <Feather
                name="x"
                size={32}
                color={Colors.lightGray}
                style={styles.iconX}
              />
            </TouchableOpacity>
          </View>
          <Text
            style={{
              fontSize: 20,
              lineHeight: 26,
              color: 'black',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 20,
            }}>
            Pedido com entrega programada
          </Text>

          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 30,
            }}>
            Notamos que você tem um
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 10,
            }}>
            pedido com entrega
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 200,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 10,
            }}>
            programada para {date}.
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: 'black',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 30,
            }}>
            Gostaria de fazer um pedido adicional?
          </Text>
          <View style={styles.containerButton}>
            <ButtonComponent
              title="Meus pedidos"
              outlined
              width="48%"
              onPress={handleOrdersPress}
            />
            <ButtonComponent title="Continuar" width="48%" onPress={onPress} />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default OrderScheduledModal;
